export default __webpack_public_path__ + "static/media/developer-picturemark-d.e648ce11.svg";